import styled from 'styled-components';
import { List as BaseList } from 'antd';

export const List = styled(BaseList)`
  & > .ant-spin-nested-loading > .ant-spin-container > .ant-list-items {
    display: flex;
    flex-direction: column;
  }
`;
